export default __webpack_public_path__ + "static/10-mob-app-dfebf90489b020cd2b7f586277690760.png";